import { DataActiveStatusEnum } from "../../Category/types";
import { NewsState, IData } from "../types";

export const defaultFormData: IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  status: DataActiveStatusEnum.ACTIVE,
  link: "",
  title: "",
  description: "",
  featuredImage: "",
  image: ""
};

export const initialState: NewsState = {
  formData: { ...defaultFormData },
  list: [],
  allList: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
};
